var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSettingIco2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64.093,
    height: 64.093,
    viewBox: "0 0 64.093 64.093",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: -0.407,
    x2: 0.5,
    y2: 1.127,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003,
    stopColor: "#5c0cec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#2979ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1fcbff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    y1: -6.408,
    x2: 0.5,
    y2: 5.279,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_53",
    "data-name": "Group 53",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M2080.279,2665l1.088,10.562,4.189-.432a27.786,27.786,0,0,0,5.32,9.866l-2.65,3.26,8.237,6.7,2.65-3.259a27.831,27.831,0,0,0,10.745,3.2l.432,4.189,10.561-1.088-.432-4.189a27.814,27.814,0,0,0,9.868-5.321l3.259,2.651,6.7-8.238-3.259-2.65a27.829,27.829,0,0,0,3.2-10.745l4.19-.432-1.089-10.561-4.189.432a27.822,27.822,0,0,0-5.321-9.868l2.65-3.259-8.237-6.7-2.65,3.259a27.823,27.823,0,0,0-10.745-3.2l-.432-4.189-10.561,1.088.432,4.19a27.816,27.816,0,0,0-9.868,5.32l-3.259-2.65-6.7,8.237,3.26,2.65a27.79,27.79,0,0,0-3.2,10.745Zm30.2-15.85a17.979,17.979,0,1,1-16.042,19.728A17.98,17.98,0,0,1,2110.482,2649.148Z",
    transform: "translate(-2080.279 -2634.986)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M2163.894,2722.355a4.207,4.207,0,1,0-4.616-3.754A4.207,4.207,0,0,0,2163.894,2722.355Z",
    transform: "translate(-2131.417 -2686.124)",
    fill: "url(#linear-gradient-2)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingIco2);
export default __webpack_public_path__ + "static/media/settingIco2.0b525d9242494abec1e27559262180a7.svg";
export { ForwardRef as ReactComponent };